import { Http } from '../utils/Http'
import { SerializationHelper } from '../utils/SerializationHelper'
import { AbstractModel } from './AbstractModel'

export class MinioRessource extends AbstractModel {
  path: string | null = null

  static async getAllForContext (context: string): Promise<MinioRessource[]> {
    const res = await Http.request(`/api/minio-ressource/context/${context}`)
    const data = await res.json()
    return SerializationHelper.toInstanceArray(MinioRessource, data)
  }
}
